<script setup lang="ts">
import { ref } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import PrintersCustomTable from '@/components/customTables/PrintersCustomTable.vue';
import ReportGenerateDialogHeader from '@/components/headers/ReportGenerateDialogHeader.vue';
import PageDialogWrapper from '@/components/wrappers/PageDialogWrapper.vue';
import usePrintDialogData from '@/composables/data/usePrintDialogData';

export interface Props {
  isConfirmLoading?: boolean;
  arJobId?: number;
  arJobConnote?: string;
}
export type DefProps = typeof props;
const props = withDefaults(defineProps<Props>(), {
  isConfirmLoading: false,
  arJobId: undefined,
  arJobConnote: undefined,
});
const emit = defineEmits<{
  cancelBtnClick: [event: Event];
  confirmBtnClick: [event: Event, selectedPrinterId: number, props: DefProps];
}>();

const { isFetchingUserPrinters, userPrinters } = usePrintDialogData();

function handleCancelClick(event: Event): void {
  // also it should be wrapped with <v-dialog :persistent="isConfirmLoading"
  if (props.isConfirmLoading) return;
  emit('cancelBtnClick', event);
}

function handleConfirmClick(event: Event): void {
  if (props.isConfirmLoading) return;
  emit('confirmBtnClick', event, selectedPrinterId.value, props);
}

const selectedPrinterId = ref(NaN);

function handleSelectPrinter(printerId: number): void {
  selectedPrinterId.value = printerId;
}
</script>

<template>
  <PageDialogWrapper :class="$style.printDialog" data-testid="printDialog">
    <template #header>
      <ReportGenerateDialogHeader @close-click="handleCancelClick">
        AirRoad job {{ props.arJobConnote }}: Choose a printer
      </ReportGenerateDialogHeader>
    </template>
    <section ref="main" :class="$style.main">
      <div class="mx-n8">
        <PrintersCustomTable
          :printers="userPrinters"
          :loading="isFetchingUserPrinters"
          @select-printer="handleSelectPrinter"
        />
      </div>
    </section>
    <template #footer>
      <menu :class="$style.dialogFooterMenuList">
        <li :class="$style.dialogFooterMenuListItem">
          <KBtn
            variant="outlined"
            append-icon="mdi-close"
            :class="$style.btn"
            @click="handleCancelClick"
          >
            Cancel
          </KBtn>
        </li>
        <li :class="$style.dialogFooterMenuListItem">
          <KBtn
            append-icon="mdi-printer-outline"
            :class="$style.btn"
            :loading="props.isConfirmLoading"
            :disabled="!props.arJobId || !selectedPrinterId"
            @click="handleConfirmClick"
          >
            Print
          </KBtn>
        </li>
      </menu>
    </template>
  </PageDialogWrapper>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.printDialog {
  width: 520px;
}
  .main {
  }
  .dialogFooterMenuList {
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: right;
  }
    .dialogFooterMenuListItem {
      display: inline;
    }
    .dialogFooterMenuListItem + .dialogFooterMenuListItem {
      margin-left: 1rem;
    }
      .btn {
      }
</style>
